import REALTIMESOLUTION from './markPoint/REALTIMESOLUTION';
import ABNORMALTRANSACTION from './markPoint/ABNORMALTRANSACTION';

/**
 * MARKPOINT类定义
 */
class MARKPOINT {
    /**
     * MARKPOINT类构造函数
     * @param {Object} markPointOption markPoint选项
     * @param {Object} markPointDataObj 需要标注的点
     * @param {Array<String>} times 交易时间序列
     * @param {Array<Array<Number>>} klineDatas K线数据
     */
    constructor(markPointOption, markPointDataObj = {}, times = [], klineDatas = []) {
        // 剔除无效的MarkPoint数据
        this.deleteInvalidData(markPointDataObj, times);

        this.fixedMarkPoints = this.generateFixedMarkPointOption(markPointOption.maxAndMin);

        // 方便生成option时，直接根据配置项调用，所以全部都采用小写字母
        this.realtimesolution = new REALTIMESOLUTION(
            markPointOption.realtimeSolution,
            markPointDataObj.realtimesolution,
            klineDatas
        );
        this.abnormaltransaction = new ABNORMALTRANSACTION(
            markPointOption.abnormalTransaction,
            markPointDataObj.abnormaltransaction
        );
    }

    /**
     * 删除无效的MarkPoint数据
     * @param {Object} markPoint 需要标注的点
     * @param {Array<String>} times 交易时间序列
     */
    deleteInvalidData(markPoint, times) {
        Object.keys(markPoint).forEach(type => {
            let results = [];
            markPoint[type].forEach(point => {
                let index = times.findIndex(time => time === point.time);
                // 如果没有找到，则不标点
                if (index === -1) {
                    return;
                }
                // 处理坐标的方法需要交易时间的索引
                point.timeIndex = index;
                results.push(point);
            });
            markPoint[type] = results;
        });
    }

    /**
     * 生成固定的MarkPoint选项
     * @param {Object} option 固定标记点的选项
     * @returns {Array<Object>} 返回生成的固定标记点选项
     */
    generateFixedMarkPointOption(option) {
        let fixedMarkPoints = [
            {
                name: '最大值',
                type: 'max',
                valueDim: 'highest'
            },
            {
                name: '最小值',
                type: 'min',
                valueDim: 'lowest'
            }
        ];
        // 处理固定的点，增加echarts选项
        return fixedMarkPoints.map(point => {
            let cloneOption = JSON.parse(JSON.stringify(option));
            return {
                ...cloneOption,
                ...point
            };
        });
    }

    /**
     * 生成MarkPoint选项
     * @param {Array<String>} showMarkPointTypes 要显示的MarkPoint类型
     * @returns {Array<Object>} 返回处理后的MarkPoints
     */
    generateMarkPointOption(showMarkPointTypes) {
        // 增加固定的点
        let markPoints = this.fixedMarkPoints;

        showMarkPointTypes.forEach(type => {
            let markPointObj = this[type.toLowerCase()];
            if (markPointObj) {
                markPoints = markPoints.concat(markPointObj.generateMarkPointOption(this.klineDatas));
            }
        });

        return markPoints;
    }
}

export default MARKPOINT;



// WEBPACK FOOTER //
// ./src/controller/series/MARKPOINT.js